(function () {
  angular
    .module('specsguardApp')
    .controller('DocumentAddController', DocumentAddController);

  DocumentAddController.$inject = ['Project', '$mdDialog', 'Labels', 'project', 'documentType',
    'currentDocs', 'model', 'sgAutocompleteHelpers', 'ProjectBusinessService'];

  function DocumentAddController(ProjectAPI, $mdDialog, Labels, project, documentType,
                                 currentDocs, model, sgAutocompleteHelpers, ProjectBusinessService) {

    const vm = this;

    vm.LABELS = Labels;
    vm.documentType = documentType;
    vm.availableVersions = project.availableVersions;
    vm.model = model;
    vm.form = {ref: {}};


    vm.descriptionValid = () => {
      const isValidName = !currentDocs.find((doc) => {
        const extIdx = doc.file.name.indexOf('.pdf');
        if (extIdx !== -1) {
          return doc.file.name === vm.model.name || doc.file.name.slice(0, extIdx) === vm.model.name;
        }
        return doc.file.name === vm.model.name;
      });

      vm.form.ref.name.$setValidity('uniqueName', isValidName);

      if (isValidName) {
        vm.form.ref.documentTitle = vm.form.ref.name;
      }

    };

    vm.$onInit = () => {
      vm[`set${vm.documentType}`]();
    };

    vm.submit = function () {

      vm.submitting = true;
      if (vm.form.ref.$valid) {
        $mdDialog.hide(vm.model);
      } else {
        vm.submitting = false;
      }
    };

    vm.cancel = () => {
      $mdDialog.cancel();
    };

    vm.setTextual = () => {
      vm.fieldsObj.documentImage = {
        fieldType: 'imagepicker',
        label: vm.LABELS.getLabel('documentimage'),
        helpKey: 'documentimage',
        required: false,
        multi: false,
        options: ProjectBusinessService.getProjectImages(project),
        optionsMapping: {
          displayNameKey: 'path',
          valueKey: 'fileUrlPath'
        }
      };
      vm.fieldsObj.documentTitle = {
        fieldType: 'input',
        label: vm.LABELS.getLabel('documenttitle'),
        required: true,
        helpKey: 'documenttitle',
      };

      vm.fieldsObj.documentSubtitle = {
        fieldType: 'input',
        label: vm.LABELS.getLabel('documentsubtitle'),
        required: false,
        helpKey: 'documentsubtitle',
      };
    };

    vm.changeExtended = ({value, item, key, form}) => {
      vm.model.basicAreas = !value;
    };

    vm.setTechnical = () => {
      vm.fieldsObj.type = {
        fieldType: 'checkbox',
        helpKey: 'extendedspecbook',
        onChange: vm.changeExtended,
        label: vm.LABELS.getLabel('extendedspecbook'),
      };
      vm.fieldsObj.areaList = {
        fieldType: 'checkbox',
        helpKey: 'includearealist',
        label: vm.LABELS.getLabel('includearealist'),
      };
      vm.fieldsObj.basicAreas = {
        fieldType: 'checkbox',
        disabled: false,
        helpKey: 'includeareatemplates',
        label: vm.LABELS.getPlural('includeareatemplates'),
      };
      vm.fieldsObj.areas = {
        fieldType: 'checkbox',
        helpKey: 'includeareas',
        label: vm.LABELS.getPlural('includeareas'),
      };
    };

    vm.fieldsObj = {
      name: {
        fieldType: 'input',
        label: vm.LABELS.getLabel('filename'),
        postfix: '.pdf',
        required: true,
        onChange: vm.descriptionValid,
        helpKey: 'name',
      },
      versionNumber: {
        fieldType: 'input',
        label: vm.LABELS.getLabel('version'),
        required: false,
        helpKey: 'version'
      }
      // TODO once we enable multiple version support, uncomment this
      // version: {
      //   fieldType: 'dropdown',
      //   label: vm.LABELS.getLabel('version'),
      //   required: true,
      //   options: vm.availableVersions,
      //   optionsMapping: {
      //     displayNameKey: 'versionName',
      //     valueKey: '_id'
      //   },
      //   helpKey: 'version',
      //   filter: sgAutocompleteHelpers.filter
      // }
    };

    vm.buttonsCb = (i) => {
      vm.buttons[i].cb();
    };

    vm.buttons = [{
      label: vm.LABELS.getLabel('cancel'),
      type: 'button',
      cb: vm.cancel,
    }, {
      label: vm.LABELS.getLabel('save'),
      type: 'submit',
      icon: 'save',
      validateForm: true,
      cb: vm.submit,
    }];
  }
})();
